<script>
import { defineComponent, computed } from "vue";
import SidebarRouteLink from "@kit/components/SidebarRouteLink.vue";
import NavMainSearch from "@kit/components/NavMainSearch.vue";
import SideNavDrawerBase from "@kit/components/SideNavDrawerBase.vue";
import { searchWidgetMobile, sideDrawer  } from "@project/themes";
import IconButton from '@kit/components/IconButton.vue'
import { getCurrentYear } from '@kit/utils/Formats'
import { inBrowser } from '@kit/utils/EnvironmentHelper'

export default defineComponent({
  name: "SizeNavDrawer",
  setup() {

    return { searchWidgetMobile, sideDrawer, getCurrentYear, inBrowser };

  },
  components: {
    SideNavDrawerBase,
    SidebarRouteLink,
    NavMainSearch,
    IconButton
  },
});
</script>

<style>

.hamburger-button {
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 20px;
    border-top: 4px solid #FFFFFF;
    border-bottom: 4px solid #FFFFFF;
    width: 50px;
    height: 30px;
    cursor: pointer;
}

.hamburger-button::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 4px;
    left: 0;
    right: 0;
    background: #FFFFFF;
}

.hta-side-nav-drawer {
  background: var(--green-blue);
  opacity: 1;
}


.hta-sidenav-item > a {
  color:white;
  font-size:1.5rem !important;
}
.hta-sidenav-copyright {
  color:white;
  font-size:1.2rem;
}

</style>

<template>
  <SideNavDrawerBase :theme="sideDrawer">
    <template #nav-items="{ active }">

      <div class="sb hta-sidenav-item">
        <SidebarRouteLink to="/">Home</SidebarRouteLink>
      </div>

      <div class="sb sb-text hta-sidenav-copyright">
        © {{ getCurrentYear() }} ICS. All rights reserved
      </div>

    </template>
  </SideNavDrawerBase>
</template>
